module.exports = {
      id: "icon-playstore-usage",
      viewBox: "0 0 190.654 62.305",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-playstore",
      toString: function () {
        return this.url;
      }
    }